import { useContext } from 'react';

import { ThemeContext } from '../../contexts/theme';
import { bulbB, bulbW, questionBen, questionWen, questionBpt, questionWpt, questionBsv, questionWsv } from '../../assets/index';
import './Theme.css';

/* ------------------------- component ------------------------- */
const Theme = () => {
  const [{ themeName, toggleTheme }] = useContext(ThemeContext);
  let chosenLanguage = JSON.parse(localStorage.getItem('currentLanguage'));

  if (!chosenLanguage) { chosenLanguage = 'en' };

  /* ------------------------- render ------------------------- */
  return (
    <div className='theme-choice'>
      <button
        type='button'
        onClick={toggleTheme}
        className='btn btn-icon theme'
        aria-label='toggle theme'
      >
        {themeName && chosenLanguage === 'en' ? (
          <img className='question-img' alt='question mode' src={themeName === 'dark' ? (questionWen) : (questionBen)} />
        ) : null}
        {themeName && chosenLanguage === 'pt' ? (
          <img className='question-img' alt='question mode' src={themeName === 'dark' ? (questionWpt) : (questionBpt)} />
        ) : null}
        {themeName && chosenLanguage === 'sv' ? (
          <img className='question-img' alt='question mode' src={themeName === 'dark' ? (questionWsv) : (questionBsv)} />
        ) : null}
        <img className='lightbulb-img' alt='lightbulb' src={themeName === 'dark' ? (bulbW) : (bulbB)} />
      </button>
    </div>
  );
};

export default Theme;
